export const MANUAL_PORTAL_INVITE_MSG =
  "Отправка ссылки не удалась — отправьте её клиенту вручную";

/** Обратная связь после отправки / создания ссылки активации клиентского портала. */
export async function showPortalInviteFeedback(toast, response, baseMessage) {
  const emailSent = Boolean(response?.invite_email_sent);
  const smsSent = Boolean(response?.invite_sms_sent);
  const inviteUrl = response?.invite_url || null;
  const message = response?.message || "";

  if (emailSent || smsSent) {
    toast.success(message || baseMessage);
    return { inviteUrl, copied: false };
  }

  if (inviteUrl) {
    try {
      await navigator.clipboard.writeText(inviteUrl);
      toast.info(`${MANUAL_PORTAL_INVITE_MSG}. Ссылка скопирована в буфер обмена`);
      return { inviteUrl, copied: true };
    } catch {
      toast.info(MANUAL_PORTAL_INVITE_MSG);
      return { inviteUrl, copied: false, needsManualCopy: true };
    }
  }

  if (
    message.includes("отправлен") ||
    message.includes("email") ||
    message.includes("SMS")
  ) {
    toast.error(message || MANUAL_PORTAL_INVITE_MSG);
    return { inviteUrl: null, copied: false };
  }

  toast.success(message || baseMessage);
  return { inviteUrl: null, copied: false };
}

export function promptPortalInviteCopy(inviteUrl) {
  if (!inviteUrl || typeof window === "undefined") return;
  window.prompt(`${MANUAL_PORTAL_INVITE_MSG}\n\nСсылка для клиента:`, inviteUrl);
}
